export const initOptions = {
  fallbackLng: "en",
  defaultNS: "translation",
  lng: "en",
  debug: false,
  keySeparator: false,
  initImmediate: false,
  preload: ["en"],
  react: {
    wait: true,
    useSuspense: false,
  },
  interpolation: {
    escapeValue: true, // not needed for react as it escapes by default
  },
};
